import Image from 'next/image';

interface LayeredImageProps {
  images: string[];
}

export function LayeredImage({ images }: LayeredImageProps): JSX.Element {
  return (
    <div className={'relative h-full w-full'}>
      {images.map((src) => (
        <Image
          className={'absolute top-0 h-full w-full object-contain'}
          alt=''
          key={src}
          src={src}
          width={0}
          height={0}
        />
      ))}
    </div>
  );
}
